/* eslint-disable no-plusplus */

// Novo CNPJ alfanumérico (vigente a partir de julho/2026):
// - As 12 primeiras posições aceitam letras (A-Z) e dígitos (0-9).
// - Os 2 dígitos verificadores continuam sendo apenas numéricos.
// - O cálculo do DV usa o valor ASCII do caractere subtraído de 48
//   ('0' -> 0, '9' -> 9, 'A' -> 17 ...). Para um CNPJ totalmente
//   numérico o resultado é idêntico ao algoritmo antigo, garantindo
//   retrocompatibilidade com os documentos já existentes.
const CNPJ_BASE_LENGTH = 12;
const CNPJ_LENGTH = 14;
const CNPJ_BASE_REGEX = /^[A-Z\d]{12}\d{2}$/;

const charValue = (char: string): number => char.charCodeAt(0) - 48;

export function validateLegalDocument(document: string): boolean {
  if (document === undefined || typeof document !== 'string') {
    return false;
  }

  const strCNPJ = document.replace(/[./-]/g, '').toUpperCase();

  if (strCNPJ.length !== CNPJ_LENGTH || !CNPJ_BASE_REGEX.test(strCNPJ)) {
    return false;
  }

  // Rejeita documentos com todos os caracteres iguais (ex.: 00000000000000).
  if (new Set(strCNPJ).size === 1) {
    return false;
  }

  const calculateDigit = (length: number): number => {
    let soma = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      soma += charValue(strCNPJ.charAt(length - i)) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    return soma % 11 < 2 ? 0 : 11 - (soma % 11);
  };

  const digitos = strCNPJ.substring(CNPJ_BASE_LENGTH);

  if (calculateDigit(CNPJ_BASE_LENGTH) !== Number(digitos.charAt(0))) {
    return false;
  }

  if (calculateDigit(CNPJ_BASE_LENGTH + 1) !== Number(digitos.charAt(1))) {
    return false;
  }

  return true;
}
